import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { fetchApplianceMapping } from "../../../dataFetchers/appliancesDataFetcher";
import { queryRecoCardLoaded } from '../../../actions/recoDetailsActions';
import { getBECompatibleLocale } from '../../../helpers/helper';

import RecoDetailsContainer from './RecoDetailsContainer';
import { getPilotId } from '../../../helpers/userHelper';

class RecoDetailsPageMain extends React.Component {
    componentDidMount(){
        const configs = this.props.configs.data;
        const isPublic = this.props.isPublic;
        const pilotId = getPilotId();

        if (isPublic) {
            let locale = getBECompatibleLocale(configs);
            let applianceIds = configs['public.applianceIds'];
            this.props.fetchApplianceMapping({isPublic, pilotId, locale, applianceIds});
        }
    }

    isFeatureEnabled(feature){
        let featureKeyPrefix = this.props.isPublic ? 'public' : 'dashboard';
        return this.props.configs.data[`${featureKeyPrefix}.marketplace.${feature}`] === "true";
    }

    handleClick(link) {
        window.open(link);
    }

    render() {
        const marketplaceCTAEnabled = this.isFeatureEnabled('marketplaceCTAEnabled');
        const recoId = this.props.match.params.recoId;
        const applianceList = this.props.applianceList;
        const isPublic = this.props.isPublic;

        return (
            <div className={`reco-details-page ${isPublic ? 'public' : ''}`}>
                { applianceList ?
                    <RecoDetailsContainer
                        isPublic={ this.props.isPublic }
                        activeReco={recoId}
                        hideClose={true}
                        onRecoLike={(recoId, event) => this.handleRecoLikeUnlike(recoId, event)}
                        onRecoUnlike={(recoId, event) => this.handleRecoLikeUnlike(recoId, event)}
                        marketplaceCTAEnabled={marketplaceCTAEnabled}
                        openPurchaseLink={(link)=>this.handleClick(link)}/>
                : ''}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        userIdentityDetails: state.userIdentityDetails,
        configs: state.configs,
        translations: state.translationsData,
        applianceList: state.appliances.appliancesList,
        recoDetailsData : state.recoDetailsData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        queryRecoCardLoaded : () => dispatch(queryRecoCardLoaded()),
        fetchApplianceMapping: (options) => dispatch(fetchApplianceMapping(options)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RecoDetailsPageMain));